import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsXmlfieldsService } from './edit-dialogs-xmlfields.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-xmlfields',
  templateUrl: './edit-dialogs-xmlfields.component.html',
  styleUrls: ['./edit-dialogs-xmlfields.component.scss']
})
export class EditDialogsXmlfieldsComponent implements OnInit {

  /** Subscripción para el guardado de un xmldef */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsXmlfieldsService: EditDialogsXmlfieldsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsXmlfieldsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsXmlfieldsService.build(); }

  ngOnInit() {
    this.editDialogsXmlfieldsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Xmlfield
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsXmlfieldsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del xmlfield está ausente
      // -1: El número del xmlfield ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorXmlFields('WARNINGS.error_nuevo');
      }else{
        console.log(value);
        //window.location.reload();
      }
      this.loading = false;

    }, error => {
      console.log(error);
      this.errorXmlFields('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog xmlfield
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let xmlfield = this.editDialogsXmlfieldsService.xmlfields;
    let original = this.editDialogsXmlfieldsService.originalXmlfields;
    return this.editDialogsXmlfieldsService.compare(xmlfield, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorXmlFields(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
